import React from 'react';
import { Box, CircularProgress, makeStyles } from '@material-ui/core';
import { t } from 'i18next';

const useStyles = makeStyles((theme) => ({
    processContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(2),
        color: theme.palette.black,
        fontSize: '15px',
        justifyContent: 'center'
    },
    stopButton: {
        cursor: 'pointer',
        color: theme.palette.black,
        backgroundColor: theme.palette.white,
        borderRadius: theme.spacing(2.5),
        padding: theme.spacing(.5, 1),
        fontWeight: 'bold',
        // marginLeft: theme.spacing(6),
        animation: '$blink 1s infinite',
    },
    '@keyframes blink': {
        '0%, 100%': {
            border: '2px solid red',
        },
        '50%': {
            border: '2px solid orange',
        },
    },

}));

export const ChatProcessing = ({ chatProcess, abortCtlr }) => {
    const classes = useStyles();
    return (
        <div className='spinnerContainer'>
            <Box className={classes.processContainer} data-testid="chat-process">
                <CircularProgress color='secondary' size={15} />
                <span>{chatProcess}</span>
            </Box>
            {abortCtlr && <center>
                <button
                    className={classes.stopButton}
                    onClick={() => abortCtlr.abort('cancelled')}
                    data-testid="stop-chat-btn"
                >
                    {t('stop')}
                </button>
            </center>}
        </div>
    );
}